<template>
	<template v-if="name">
      <Tag 
      class="ml-2  mb-2 custom-chip" 
      :value="name" 
      :style="'background-color:#'+color"
      /> 
    </template>
</template>

<script>
export default {

  name: 'PlannerTableSelectAttribute',
  props:["customattributefilters","column_id","column_data"],
  data () {
    return {

    }
  },
  computed:{
  	name()
  	{
  		if(this.column_id && this.column_data && this.customattributefilters)
  		{
  			let the_column = this.customattributefilters.find(item=>item.id == this.column_id)
  			let data = this.column_data[this.column_id+"_select"]
				if(data)
				{
					
					let option = the_column.fulloptions.find(item=>item.id == data)
					if(option)
					{
					  return option.name
					}
					return null
				}
				return null
  		}
  		return null
  	},
  	color()
  	{
  		if(this.column_id && this.column_data && this.customattributefilters)
  		{
  			let the_column = this.customattributefilters.find(item=>item.id == this.column_id)
  			let data = this.column_data[this.column_id+"_select"]
			if(data)
			{
				
				let option = the_column.fulloptions.find(item=>item.id == data)
				if(option)
				{
				  if(option.color)
				  {
				  	return option.color
				  }
				}
				return "3b82f6"
			}
			return "3b82f6"
  		}
  		return null
  	},
  }
}
</script>

<style lang="css" scoped>
</style>